<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver a lista de Documentos"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinnerGuardando && hasAddingAccess" [disabled]="actionNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<app-documento-ui-edit *ngIf="unidadInspeccion" [IdUiCam]="unidadInspeccion?.IdUi" [documentoUI]="documentoDetalleUI" [formGroup]="form" [readonly]="readonly"
                (fileUpload)="onFileUpload($event)">
</app-documento-ui-edit>
